module.exports = flarum.core.compat['components/TextEditorButton'];